export default __webpack_public_path__ + "static/media/lagu-pernikahan-impian.1b389d22.mp3";